import styled from 'styled-components'

export const LottieContainer = styled.div`
  svg {
    width: 16px !important;
    height: 16px !important;
  }
`
